import { AxiosRequestConfig } from 'axios';
import Dexie from 'dexie';
import { FilterArray } from '../../../../functions/FilterArray';
import { isAnimal } from '../../../../functions/IsAnimal';
import { IToPerform } from '../entities/IToPerform';

export class ToPerformRepository {
  private repository: Dexie.Table<IToPerform, number>;

  constructor(toPerformTable: Dexie.Table<IToPerform, number>) {
    this.repository = toPerformTable;
  }

  public async findAllAnimals(): Promise<IToPerform[]> {
    const data = await this.repository.toArray();

    return data.filter(item => isAnimal(item.data));
  }
}
